import { render, staticRenderFns } from "./ComprasCardGeneric.vue?vue&type=template&id=14c7a3f8"
import script from "./ComprasCardGeneric.vue?vue&type=script&lang=js"
export * from "./ComprasCardGeneric.vue?vue&type=script&lang=js"
import style0 from "./ComprasCardGeneric.vue?vue&type=style&index=0&id=14c7a3f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports